import React from "react";
import PropTypes from "prop-types";
import styles from "./TagMonster.module.css";
import TagMonsterChild from "../TagMonsterChild";
import { useTranslation } from "react-i18next";

/*
 *Displays a list of tags used to filter down data
 */
export function TagMonster({
  categories,
  onClick,
  selectedCategory,
  variant = "default",
  segmentedTheme = "soft",
}) {
  const { t } = useTranslation();
  const firstRow = categories.filter((category) => category.rowNumber == 1);
  const secondRow = categories.filter((category) => category.rowNumber == 2);

  const handleCategoryClick = (category) => {
    onClick(category);
  };

  return (
    <div>
      <div
        className={`${styles.container} ${
          variant === "segmented" ? styles.segmentedContainer : ""
        }`}
      >
        {firstRow.map((category, index) => (
          <div
            className={styles.content}
            key={`row1-${index}`}
            onClick={() => handleCategoryClick(category.title)}
          >
            <TagMonsterChild
              backgroundColor={
                selectedCategory === category.title ? "#415364" : "#ADB7C0"
              }
              color={"#FFFF"}
              selected={selectedCategory === category.title}
              variant={variant}
              segmentedTheme={segmentedTheme}
              children={t(category.title)}
            />
          </div>
        ))}
      </div>

      {secondRow.length > 0 && (
        <div
          className={`${styles.container} ${
            variant === "segmented" ? styles.segmentedContainer : ""
          }`}
        >
          {secondRow.map((category, index) => (
            <div
              className={styles.content}
              key={`row2-${index}`}
              onClick={() => handleCategoryClick(category.title)}
            >
              <TagMonsterChild
                backgroundColor={
                  selectedCategory === category.title ? "#415364" : "#ADB7C0"
                }
                color={"#FFFF"}
                selected={selectedCategory === category.title}
                variant={variant}
                segmentedTheme={segmentedTheme}
                children={t(category.title)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

TagMonster.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  onClick: PropTypes.func,
  selectedCategory: PropTypes.string,
  variant: PropTypes.oneOf(["default", "segmented"]),
  segmentedTheme: PropTypes.oneOf(["soft", "white"]),
};
